import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";
import profile from "../assets/profile.jpeg";
import Testimonials from "../components/Testimonials";
import { updateMetaTags } from "../lib/seo";

/**
 * Home page hero with a short professional summary and subtle animation.
 * Animations respect the user's `prefers-reduced-motion` setting.
 * Enhanced with comprehensive SEO optimization.
 */
const Home = () => {
  useEffect(() => {
    // Enhanced SEO Meta Tags
    updateMetaTags({
      title:
        "Astrologija v Vortexu | Profesionalne Natalne Karte & Sinastrija Slovenije",
      description:
        "Profesionalne astrološke storitve v Sloveniji. Natalna karta (€99), sinastrija za pare (€99), solarni horoskop (€99). Online in osebno svetovanje z več kot 10-letnimi izkušnjami. Odkrijte svoj astrološki potencial danes!",
      keywords:
        "astrologija slovenija, natalna karta, sinastrija, horoskop slovenija, astrolog, astrološko svetovanje, osebna astrologija, karmična analiza, solarni horoskop, partnerska analiza, online astrolog, profesionalni astrolog slovenija",
      canonical: "https://www.astrologijavortex.si/",
      ogImage: "https://www.astrologijavortex.si/images/og-image.jpg",
      ogType: "website",
    });
  }, []);

  return (
    <div className="home-page" itemScope itemType="https://schema.org/WebPage">
      <header className="hero" role="banner">
        <svg
          className="astro-decoration"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 200 200"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="starGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop
                offset="0%"
                style={{ stopColor: "#00a8c6", stopOpacity: 0.15 }}
              />
              <stop
                offset="100%"
                style={{ stopColor: "#004c6d", stopOpacity: 0.08 }}
              />
            </linearGradient>
          </defs>
          <circle cx="50" cy="50" r="2" fill="url(#starGrad)">
            <animate
              attributeName="opacity"
              values="0.3;1;0.3"
              dur="3s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="150" cy="80" r="1.5" fill="url(#starGrad)">
            <animate
              attributeName="opacity"
              values="0.5;1;0.5"
              dur="4s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="120" cy="150" r="2.5" fill="url(#starGrad)">
            <animate
              attributeName="opacity"
              values="0.4;0.9;0.4"
              dur="5s"
              repeatCount="indefinite"
            />
          </circle>
          <path
            d="M30 120 Q40 110 50 120 T70 120"
            stroke="url(#starGrad)"
            strokeWidth="0.5"
            fill="none"
            opacity="0.3"
          />
          <path
            d="M140 40 L145 35 L150 40 L155 35 L160 40"
            stroke="url(#starGrad)"
            strokeWidth="0.5"
            fill="none"
            opacity="0.25"
          />
        </svg>
        <div className="hero-content">
          <div className="hero-left">
            <h1 className="headline" itemProp="headline">
              Astrologija z razumom in srcem
            </h1>
            <p className="subtext" itemProp="description">
              Pomagam vam odkriti vaše potenciale, razumeti odnose in
              preobraziti izzive v priložnosti. Individualne natalne karte,
              sinastrije in svetovanje s praktičnimi koraki za vsakdan.
            </p>

            <ul className="home-summary" role="list" aria-label="Naše storitve">
              <li>Individualna interpretacija natalne karte</li>
              <li>Sinastrija za pare in odnose</li>
              <li>Praktični nasveti in osebna rast</li>
            </ul>

            <div className="hero-ctas" role="group" aria-label="Glavne akcije">
              <Link
                className="button primary"
                to="/booking"
                aria-label="Rezervirajte termin za astrološko svetovanje"
              >
                Rezerviraj termin
              </Link>
              <Link
                className="button ghost"
                to="/blog"
                aria-label="Preberite naše astrološke članke"
              >
                Preberi blog
              </Link>
            </div>
          </div>

          <div className="hero-right">
            <div className="portrait-wrap">
              <img
                src={profile}
                alt="Profesionalni astrolog - Astrologija v Vortexu"
                className="portrait"
                loading="eager"
                width="400"
                height="400"
              />
            </div>
          </div>
        </div>
      </header>

      <section aria-label="Mnenja strank">
        <Testimonials />
      </section>
    </div>
  );
};

export default Home;
